module.exports = __webpack_public_path__ + "img/Frame 5137.8624d1c3.jpg";